import React, { useState, useRef, useEffect } from 'react'
import cn from 'classnames'
import OutsideClickHandler from 'react-outside-click-handler'
import styles from './DropdownCoins.module.sass'
import Icon from '../Icon'
import { useTranslation } from 'react-i18next'

const DropdownCoins = ({
  className,
  classLabel,
  value,
  setValue,
  options,
  label,
  classDropdownHead,
  classDropdownArrow,
  classDropdownBody,
  classDropdownOption,
}) => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const searchInputRef = useRef(null)

  // Focus search input when dropdown opens
  useEffect(() => {
    if (visible && searchInputRef.current) {
      searchInputRef.current.focus()
    } else {
      setSearchTerm('')
    }
  }, [visible])

  // Filter options based on search term
  const filteredOptions = options?.filter(option => 
    option?.asset?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    option?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    option?.symbol?.toLowerCase().includes(searchTerm.toLowerCase())
  ) || []

  const handleClick = (value) => {
    setValue(value)
    setVisible(false)
  }

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      {label && <div className={cn(classLabel, styles.label)}>{label}</div>}
      <div
        className={cn(styles.dropdown, className, {
          [styles.active]: visible,
        })}
      >
        <div
          className={cn(classDropdownHead, styles.head)}
          onClick={() => setVisible(!visible)}
        >
          <div className={styles.selection}>{t(value?.asset)}</div>
          <div className={cn(styles.arrow, classDropdownArrow, { [styles.rotated]: visible })}>
            <Icon name="arrow-down" size="24" />
          </div>
        </div>
        <div className={cn(classDropdownBody, styles.body)}>
          <div className={styles.searchContainer}>
            <input
              ref={searchInputRef}
              type="text"
              className={styles.searchInput}
              placeholder={t('Search coins...')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className={styles.optionsContainer}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((x, index) => (
                <div
                  className={cn(classDropdownOption, styles.option, {
                    [styles.selectioned]: x?._id === value?._id,
                  })}
                  onClick={() => handleClick(x, index)}
                  key={index}
                >
                  {t(x?.asset)}
                </div>
              ))
            ) : (
              <div className={styles.noResults}>
                {t('No coins found')}
              </div>
            )}
          </div>
        </div>
      </div>
    </OutsideClickHandler>
  )
}

export default DropdownCoins
